import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { quienSoy } from '../services/authService';

// Identidad del usuario logueado (si la hay). `jugadorId` es null si no hay
// sesión o si el usuario es ADMIN/COMITE sin jugador vinculado -- en ambos
// casos no se puede filtrar "mis partidos".
const AuthContext = createContext({ usuario: null, cargando: true, recargar: () => {} });

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [cargando, setCargando] = useState(true);

  // Se vuelve a llamar tras el login: la identidad cargada al arrancar (sin
  // sesión) quedaría obsoleta.
  const recargar = useCallback(
    () => quienSoy()
      .then((r) => setUsuario(r.datos))
      .catch(() => setUsuario(null))
      .finally(() => setCargando(false)),
    [],
  );

  useEffect(() => { recargar(); }, [recargar]);

  return (
    <AuthContext.Provider value={{ usuario, cargando, recargar }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
